import { InputAdornment, TextField } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";

const InputText = ({
  required,
  label,
  helperText,
  defaultValue,
  error,
  value,
  onChange,
  color,
  disabled,
  variant,
  classes,
  inputType,
  inputRef,
  placeholder,
  autoFocus,
  className,
  maxLength,
  minLength,
  size,
  focused,
  Icon,
  onBlur,
  name,
  id,
  autocomplete,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const valueRef = useRef(value);
  const timeout = useRef(null);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const changeHandler = (e) => {
    const value = e.target.value;
    valueRef.current = value;
    setInputValue(value);
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      onChange(value);
    }, 300);
  };

  const onBlurHandler = () => {
    if (onBlur) {
      onBlur(valueRef.current);
    }
  };
  return (
    <TextField
      color={color || "primary"}
      required={required}
      error={error}
      label={label}
      focused={focused}
      defaultValue={defaultValue}
      helperText={helperText}
      value={inputValue || ""}
      disabled={disabled}
      onChange={changeHandler}
      className={[classes, className].join(" ")}
      margin="normal"
      variant={variant}
      type={inputType || "text"}
      name={name}
      id={id}
      inputRef={inputRef}
      placeholder={placeholder}
      autoFocus={autoFocus}
      onBlur={onBlurHandler}
      InputProps={{
        maxLength: maxLength ? maxLength : null,
        minLength: minLength ? minLength : null,
        startAdornment: Icon ? <InputAdornment position="start">{<Icon />}</InputAdornment> : null,
        autoComplete: autocomplete || "off",
        // autoComplete: 'new-password',
      }}
      size={size || "small"}
      autoComplete={autocomplete || "off"}
    />
  );
};

export default InputText;
